export default "__VITE_ASSET__52dc4191__"